import React from 'react';
import './RoomDetails.css'; // Usamos las mismas clases para mantener el layout

const RoomDetailSkeleton: React.FC = () => {
    return (
        <div className="room-page-container">
            {/* 1. Hero Skeleton */}
            <div className="room-hero skeleton" style={{ minHeight: '60vh' }}></div>

            <div className="room-content-container">
                {/* Título y Descripción */}
                <div className="skeleton h-10 w-3/4 mx-auto mb-6 mt-8"></div> {/* Título */}
                <div className="skeleton h-4 w-full mb-2"></div>
                <div className="skeleton h-4 w-full mb-2"></div>
                <div className="skeleton h-4 w-2/3 mb-10 mx-auto"></div>

                {/* Grid de Detalles */}
                <div className="room-details-grid">
                    {/* Columna Izquierda (Imagen Principal) */}
                    <div className="room-gallery">
                        <div className="skeleton w-full h-[400px] rounded-lg"></div>
                    </div>

                    {/* Columna Derecha (Amenidades) */}
                    <div className="room-amenities">
                        <div className="skeleton h-8 w-1/2 mb-6"></div> {/* Título Amenidades */}
                        <div className="space-y-4">
                            {[1, 2, 3, 4, 5, 6].map((i) => (
                                <div key={i} className="flex items-center gap-3 mb-3">
                                    <div className="skeleton w-6 h-6 rounded-full"></div>
                                    <div className="skeleton h-4 w-3/4"></div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoomDetailSkeleton;